import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Dropdown, Button } from "react-bootstrap";
import ProfileDefaultIcon from '../images/profile_pic.jpg';
import { Link, useNavigate } from "react-router-dom";
import { Plus, Briefcase, ShieldAlert, Menu as MenuIcon, X as XIconClose, ArrowLeft, BellIcon, User, LogOutIcon, Receipt } from 'lucide-react';
import ThemeToggle from "../components/ThemeToggle";
import userpic from "../images/user.png"
import { useUser } from '../redux/useUser';
import { webAuth } from '../utils/auth0'; // Import webAuth from utils
import { api, getAuthHeaders, globalSearch } from '../utils/api';
import logo from '../images/logo.svg';
import logoDark from '../images/logo-dark.svg';
import logoSm from '../images/logo-sm.svg';
import GlobalSearchModal from './GlobalSearchModal';

import NotificationPopup from '../components/NotificationPopup';
import '../styles/notifications.scss';


const Header = ({ isSidebarCollapsed }) => {

  const [isDark, setIsDark] = useState(false);
      useEffect(() => {
        const interval = setInterval(() => {
          const savedTheme = localStorage.getItem("theme");
          setIsDark(savedTheme === "dark");
        }, 100);
    
        return () => clearInterval(interval);
    }, []);

  const { user } = useUser();
  const [completionPercent, setCompletionPercent] = useState(Number(localStorage.getItem('profileCompletionPercent')) || 0);

  const toggleMenu = () => {
    document.body.classList.toggle("menu-opened");
  };

  const closeMenu = () => {
    document.body.classList.remove("menu-opened");
  };

  const addTablePseudoElements = () => {
    const tables = document.querySelectorAll('.mobile-table');
    tables.forEach(table => {
      const headers = table.querySelectorAll('thead th');
      if (!headers.length) return;
      const headerTexts = Array.from(headers).map(th => th.textContent.trim());
      const rows = table.querySelectorAll('tbody tr');
      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, index) => {
          if (!cell.getAttribute('data-header')) {
            cell.setAttribute('data-header', headerTexts[index] || '');
          }
        });
      });
    });
  };

  useEffect(() => {
    const hamIcon = document.getElementById("hamIcon");
    const mobileSideOverlay = document.getElementById("mobileSideOverlay");

    if (hamIcon) {
      hamIcon.addEventListener("click", toggleMenu);
    }
    if (mobileSideOverlay) {
      mobileSideOverlay.addEventListener("click", closeMenu);
    }

    addTablePseudoElements();
    const observer = new MutationObserver(mutations => {
        let needsProcessing = false;
        for (let mutation of mutations) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && (node.matches('.mobile-table') || node.querySelector('.mobile-table'))) {
                        needsProcessing = true;
                    }
                });
            }
        }
        if (needsProcessing) {
            addTablePseudoElements();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      if (hamIcon) hamIcon.removeEventListener("click", toggleMenu);
      if (mobileSideOverlay) mobileSideOverlay.removeEventListener("click", closeMenu);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === 'profileCompletionPercent') {
        setCompletionPercent(Number(e.newValue) || 0);
      }
    };
    window.addEventListener('storage', handleStorage);
    // Also poll localStorage every second for instant update in same tab
    const interval = setInterval(() => {
      const percent = Number(localStorage.getItem('profileCompletionPercent')) || 0;
      setCompletionPercent(percent);
    }, 1000);
    return () => {
      window.removeEventListener('storage', handleStorage);
      clearInterval(interval);
    };
  }, []);

  const dropdownItems = [
    { label: "Add Asset", icon: <Briefcase strokeWidth={1.5} size={18} />, action: () => {}, path: "/add-assets" },
    { label: "Add Liability", icon: <Receipt strokeWidth={1.5} size={18} />, action: () => {}, path: "/add-liability" }
  ];

  const navigate = useNavigate();

  // Logout function to clear auth state and redirect
  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_info');
    localStorage.removeItem('id_token');
    localStorage.removeItem('hideProfileBanner');
    localStorage.removeItem('profileCompletionPercent');
    localStorage.removeItem('pending_verification_email');
    localStorage.removeItem('user_profile');
    localStorage.removeItem('update_phone');
   localStorage.removeItem('phone');
    localStorage.removeItem('smsIdentity');
     localStorage.removeItem('update_phone_userId');
    navigate('/');
   
  };

  const [showPopup, setShowPopup] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'done',
      message: 'Two factor authentication enabled successfully.',
      time: '1 hr. ago',
      date: '2025-01-15',
      isRead: false
    },
    {
      id: 2,
      type: 'warning',
      message: 'Please, verify you email address',
      time: '12 hr. ago',
      date: '2025-01-14',
      isRead: false
    },
    {
      id: 3,
      type: 'critical',
      message: 'Your plan expire soon. Please, take an action.',
      time: '05-08-2025',
      date: '2025-01-13',
      isRead: true
    },
    {
      id: 4,
      type: 'general',
      message: 'Welcome John, Setup your profile from here',
      time: '26-07-2025',
      date: '2025-01-12',
      isRead: true
    }
  ]);
  const [apiUnreadCount, setApiUnreadCount] = useState(0);
  const [planType, setPlanType] = useState('');

  useEffect(() => {
    async function fetchPlanType() {
      try {
        const res = await api.get('/subscriptions/my', { headers: getAuthHeaders() });
        const sub = res.data?.subscription || res.data?.plan || res.data || {};
        const planTypeValue = sub.planId?.planType || '';
        setPlanType(planTypeValue);
      } catch (e) {
        setPlanType('');
      }
    }
    fetchPlanType();

    const handlePlanChange = () => {
      fetchPlanType();
    };

    const handleStorageChange = (e) => {
      if (e.key === 'planType' && e.newValue) {
        setPlanType(e.newValue);
      }
    };
    
    window.addEventListener('planTypeChanged', handlePlanChange);
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('planTypeChanged', handlePlanChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Global search states
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    // Fetch unread notification count from API
    async function fetchUnreadCount() {
      try {
        const res = await api.get('/notifications/analytics/unread-count', { headers: getAuthHeaders() });
        // If API returns { count: 5 } or similar
        setApiUnreadCount(res.data?.unreadCount || 0);
      } catch (e) {
        setApiUnreadCount(0);
      }
    }
    fetchUnreadCount();

    // Listen for custom event when notifications are marked as read from other components
    const handleNotificationsChanged = () => {
      fetchUnreadCount();
    };
    window.addEventListener('notificationsChanged', handleNotificationsChanged);
    
    return () => {
      window.removeEventListener('notificationsChanged', handleNotificationsChanged);
    };
  }, []);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const openFullPage = () => {
    setShowPopup(false);
    window.location.href = '/notifications';
  };

  const markAsRead = (id) => {
    setNotifications(prevNotifications =>
      prevNotifications.map(notification =>
        notification.id === id ? { ...notification, isRead: true } : notification
      )
    );
  };

  const markAllAsRead = () => {
    setNotifications(prevNotifications =>
      prevNotifications.map(notification => ({ ...notification, isRead: true }))
    );
  };

  const clearNotification = (id) => {
    setNotifications(prevNotifications =>
      prevNotifications.filter(notification => notification.id !== id)
    );
  };

  // Use API unread count if available, else fallback to local notifications
  const unreadCount = apiUnreadCount > 0 ? apiUnreadCount : '0';

  // Handle search functionality
  const handleSearch = async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      setShowSearchModal(false);
      return;
    }

    setSearchLoading(true);
    setShowSearchModal(true);
    
    try {
      const data = await globalSearch(query, 1, 100);
      setSearchResults(data.results || []);
    } catch (error) {
      console.error('Search error:', error);
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    if (value.length >= 2) {
      // Debounce search with 300ms delay
      const timeout = setTimeout(() => {
        handleSearch(value);
      }, 300);
      setSearchTimeout(timeout);
    } else {
      setSearchResults([]);
      setShowSearchModal(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      handleSearch(searchQuery);
    }
  };

  return (
    <div className="header d-flex justify-content-between align-items-center">
      <Button id="hamIcon" className="hamIcon d-md-none" variant="none"><span></span></Button>

      {/* <div className="header-breadcrumb">
        <h3>Dashboard</h3>
        <ul>
          <li><a href="/home">Home</a></li>
          <li><a href="/dashboard">Dashboard</a></li>
        </ul>
      </div> */}

      <Link to="/dashboard" className="header-logo d-md-none text-decoration-none">{!isSidebarCollapsed ? <img src={isDark ? logoDark : logo} alt="logo"/>: <img src={logoSm} alt="logo"/>}</Link>

      <Dropdown className="ms-auto add-new-dropdown me-3 me-sm-4" id="add_new_asset_dropdown">
        <Dropdown.Toggle 
            variant="primary"
            id="add_new_asset"
            className="add_new_asset"
        >
        </Dropdown.Toggle>
        <Dropdown.Menu className="asset-dropmenu">
          {dropdownItems.map((item, index) => (
            <Dropdown.Item 
              key={index} 
              as={Link} 
              to={item.path} 
              onClick={item.action} 
              className="d-flex align-items-center gap-2"
            >
              <span>{item.icon}</span> {item.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      <div className="search-profile">    
        {/* Desktop search input */}
        <div className="header_search d-none d-md-block" style={{ position: 'relative' }}>
          <form onSubmit={handleSearchSubmit}>
            <input 
              type="text" 
              name="search" 
              className={`form-control form-control-sm header-search-input ${showSearchModal ? 'expanded' : ''}`}
              placeholder="Search assets" 
              value={searchQuery}
              onChange={handleSearchInputChange}
              onFocus={() => setShowSearchModal(true)}
            />
            <Button variant="none" className="search-icon-btn" type="submit">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 10.691 10.997">
                <g id="search" transform="translate(-235 -41)">
                  <g id="Ellipse_50" transform="translate(235 41)" fill="#fff" stroke="#bcbcbc" strokeWidth="1">
                    <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                    <circle cx="4.5" cy="4.5" r="4" fill="none" />
                  </g>
                  <path id="Path_11305" d="M17914.2-416.492l3.137,3.136" transform="translate(-17672 465)" fill="none" stroke="#bcbcbc" strokeLinecap="round" strokeWidth="1" />
                </g>
              </svg>
            </Button>
          </form>
          <GlobalSearchModal
            show={showSearchModal}
            onHide={() => setShowSearchModal(false)}
            results={searchResults}
            loading={searchLoading}
            query={searchQuery}
            expandedWidth="600px"
          />
        </div>

        {/* Mobile search icon — opens search modal */}
        <button
          className="d-md-none mobile-search-icon-btn"
          onClick={() => { setShowMobileSearch(true); }}
          aria-label="Search"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 10.691 10.997">
            <g transform="translate(-235 -41)">
              <g transform="translate(235 41)" fill="#fff" stroke="#707EAE" strokeWidth="1">
                <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                <circle cx="4.5" cy="4.5" r="4" fill="none" />
              </g>
              <path d="M17914.2-416.492l3.137,3.136" transform="translate(-17672 465)" fill="none" stroke="#707EAE" strokeLinecap="round" strokeWidth="1" />
            </g>
          </svg>
        </button>

        {/* Mobile search full-screen modal */}
        {showMobileSearch && (
          <div className="mobile-search-overlay">
            <div className="mobile-search-box">
              <form onSubmit={(e) => { handleSearchSubmit(e); }} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input
                  type="text"
                  autoFocus
                  className="form-control"
                  placeholder="Search assets, liabilities..."
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  style={{ flex: 1, borderRadius: 50, border: '1px solid #e0e5f2', padding: '10px 16px' }}
                />
                <button
                  type="button"
                  onClick={() => { setShowMobileSearch(false); setShowSearchModal(false); setSearchQuery(''); setSearchResults([]); }}
                  style={{ background: 'none', border: 'none', fontSize: 22, color: '#707EAE', cursor: 'pointer', flexShrink: 0 }}
                >
                  ×
                </button>
              </form>
              {searchQuery.length >= 2 && (
                <GlobalSearchModal
                  show={true}
                  onHide={() => { setShowMobileSearch(false); setShowSearchModal(false); }}
                  results={searchResults}
                  loading={searchLoading}
                  query={searchQuery}
                  expandedWidth="100%"
                />
              )}
            </div>
          </div>
        )}

        <div className="theme-toggle">
            <ThemeToggle />
        </div>

        <div className="notification-container">
          <div className="notification-bell" onClick={togglePopup}>
            <BellIcon className="bell-icon" />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </div>
          
          {showPopup && (
            <NotificationPopup
              notifications={notifications}
              onClose={() => setShowPopup(false)}
              onViewAll={openFullPage}
              onMarkAsRead={markAsRead}
              onMarkAllAsRead={markAllAsRead}
              unreadCount={unreadCount}
              setApiUnreadCount={setApiUnreadCount}
            />
          )}
        </div>

        {planType && (
          <Link to="/editprofile?tab=billing" className="plan-type-badge p-2 text-decoration-none">{planType.toUpperCase()}</Link>
        )}

        <Dropdown align="end" className="profile-dropdown">
          <Dropdown.Toggle variant="light" id="dropdown-basic" className="border-0 bg-transparent p-0 shadow-none d-inline-flex">
            <span
              className="progress-ring"
              style={{ '--progress': completionPercent }}
            >
              <img src={user?.image ? user?.image :  userpic} alt="User Profile" width="40" height="40" className="round_img wh-40" style={{ height: '40px', width: '40px' }}/>
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item className="d-flex align-items-center" as={Link} to="/editprofile"><User strokeWidth={1.5} size={18} />Profile</Dropdown.Item>
            <Dropdown.Item className="d-flex align-items-center" as="button" onClick={logout}><LogOutIcon strokeWidth={1.5} size={18} />Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="mobileSideOverlay d-md-none" id="mobileSideOverlay"></div>
    </div>
  );
};

export default Header;